import { graphql } from "react-relay";

export const fragments = {
  user: graphql`
    fragment OnboardingSummaryStep_user on User {
      id

      dataSources(first: 1000000) {
        edges {
          node {
            id
            state
            type
            name
            ...DataSource_dataSource
          }
        }
      }
    }
  `,
  org: graphql`
    fragment OnboardingSummaryStep_org on Org {
      id
      primaryOrgCalendar
      domains
      experiments

      eventColoringSettingsErrorable {
        __typename

        ... on EventColoringSettings {
          eventCategoryColorings {
            active
            eventCategory
            googleColorKey
            isUserSet
          }
        }
      }

      primaryTeam {
        __typename
        ... on Team {
          teamId
          teamName
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
      userTeams {
        __typename
        ... on TeamList {
          list {
            teamId
          }
        }
      }

      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            targetUrn {
              id
              type
              value
            }
            otherUrns {
              id
              type
              value
            }
            name
            valueUrn {
              id
              type
              value
            }
            isDeleted
            options {
              syncToGoogle
            }
          }
        }
      }

      slackAccountsErrorable {
        __typename
        ... on SlackAccountList {
          list {
            id
            slackTeamId
            slackUserId
            teamDisplayName
            needsUpdate
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          enabledOrganized {
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
          }
          enabledAttending {
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
          }
          suggestedOrganized {
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};
